"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _dataCollection = _interopRequireDefault(require("../../../common/backbone/dataCollection"));

var _dataModel = _interopRequireDefault(require("../../../common/backbone/dataModel"));

var _indexOf2 = _interopRequireDefault(require("lodash/indexOf"));

var _crud = _interopRequireDefault(require("../sync/crud.sync"));

var _stream = _interopRequireDefault(require("../sync/stream.sync"));

/**
 * @class Базова коллекция, от которой должны наследоваться остальные
 */
var _default =
/*#__PURE__*/
function (_DataCollection) {
  (0, _inherits2["default"])(_default, _DataCollection);

  function _default() {
    var _this;

    var models = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this, models, options));

    _this._setPropertyAlias();

    _this._setQueryAlias();

    _this.syncEngines = {};
    return _this;
  }
  /**
   * @private
   */


  (0, _createClass2["default"])(_default, [{
    key: "_setPropertyAlias",
    value: function _setPropertyAlias() {
      var proto = Object.getPrototypeOf(this),
          ctr = proto.constructor;

      if (!proto.hasOwnProperty('__property_alias_was_set__')) {
        // comparator can be static string or public method
        // string should be assigned to proto
        if (ctr.comparator) {
          proto.comparator = ctr.comparator;
        }

        proto.parsers = ctr.parsers;
        proto.queryParams = ctr.queryParams;
        proto.__property_alias_was_set__ = true;
      }
    }
    /**
     * set alias methods for query settings
     * query settings must be assigned in static variable "queryParams"
     * ex: queryParams.doQuery -> this.__proto__.duQuery
     * @private
     */

  }, {
    key: "_setQueryAlias",
    value: function _setQueryAlias() {
      var proto = Object.getPrototypeOf(this);

      if (!proto.hasOwnProperty('__query_alias_was_set__')) {
        if ((0, _typeof2["default"])(this.queryParams) === 'object') {
          var name;
          var crud = ['create', 'read', 'update', 'destroy'],
              stream = ['connect', 'send'];

          for (name in this.queryParams) {
            if (this.queryParams.hasOwnProperty(name) && crud.indexOf(name) < 0 && stream.indexOf(name) < 0 && !proto[name]) {
              (function (method) {
                proto[method] = function () {
                  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  options = this._prepareQueryOptions(options);
                  return this.sync(method, options);
                };
              })(name);
            }
          }
        }

        proto.__query_alias_was_set__ = true;
      }
    }
    /**
     * @param {string} id
     * @param {any} rest
     * @return {Number}
     * @description Ищет порядковый номер модели в коллекции
     */

  }, {
    key: "indexOf",
    value: function indexOf(id) {
      // this is 'id'
      if (!(id instanceof _dataModel["default"])) {
        id = this.get(id);
      }

      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      return _indexOf2["default"].apply(void 0, [this.models, id].concat(rest));
    }
    /**
     * Подготовка параметров обновления коллекции при загрузке данных из Backbone.sync
     * Экземпляры, которые являются singleton не должны обновлять себя через reset
     * что бы не терять ссылки на существующие модели в коллекции
     * для этого устанавливаются параметры set, которыые мержат текущую коллекцию с новыми моделями
     *
     * force пропускает данную обработку
     * @param {object} options
     * @return {*|{}}
     */

  }, {
    key: "_prepareQueryOptions",
    value: function _prepareQueryOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var proto = Object.getPrototypeOf(this);

      if (!options.force && proto.singletonInstance && this === proto.singletonInstance) {
        options.reset = false;
        options.add = true;
        options.remove = true;
        options.merge = true;
      }

      return options;
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      options = this._prepareQueryOptions(options);
      return this.sync('read', options);
    }
  }, {
    key: "save",
    value: function save(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      options = this._prepareQueryOptions(options);
      this.set(data, options);
      return this.sync('create', options);
    }
  }, {
    key: "update",
    value: function update(data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      options = this._prepareQueryOptions(options);
      this.set(data, options);
      return this.sync('update', options);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      options = this._prepareQueryOptions(options);
      return this.sync('destroy', options);
    }
  }, {
    key: "connect",
    value: function connect(options) {
      return _stream["default"].call(this, 'connect', options);
    }
  }, {
    key: "send",
    value: function send(options) {
      return _stream["default"].call(this, 'send', options);
    }
  }, {
    key: "sync",
    value: function sync() {
      for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }

      return _crud["default"].call.apply(_crud["default"], [this].concat(rest));
    }
  }, {
    key: "syncResolve",
    value: function syncResolve() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this[options.reset ? 'reset' : 'set'](data, options);
      return this;
    }
  }, {
    key: "parse",
    value: function parse(data, options) {
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'read';
      var proto = Object.getPrototypeOf(this),
          ctr = proto.constructor;
      var models = data,
          parsers;
      parsers = this.parsers || ctr.parsers;
      parsers = (0, _typeof2["default"])(parsers) === 'object' ? parsers : {};

      if (typeof parsers[method] === 'function') {
        models = parsers[method].call(this, data, options);
      }

      return models;
    }
    /**
     * @return {object} singleton instance of class
     */

  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.prototype.singletonInstance) {
        var parent = this,
            Surrogate = function Surrogate() {
          var _parent$prototype$con;

          for (var _len4 = arguments.length, rest = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            rest[_key4] = arguments[_key4];
          }

          // для того что бы принимать динамическое к-во аргументов в конструктор
          return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
        };

        Surrogate.prototype = parent.prototype;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        this.prototype.singletonInstance = (0, _construct2["default"])(Surrogate, args);
      }

      return this.prototype.singletonInstance;
    }
  }]);
  return _default;
}(_dataCollection["default"]);

exports["default"] = _default;